import React from "react";
import FLFContextDevicePopup from "./FLFContextDevicePopup";

const FLFContextDeviceControlPanel = ({
  children,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  listDevice,
  setListDevice,
  clause,
  contextId,
  setContext,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <FLFContextDevicePopup
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          listDevice={listDevice}
          setListDevice={setListDevice}
          clause={clause}
          contextId={contextId}
          setContext={setContext}
        />
      </div>
    </div>
  );
};

export default FLFContextDeviceControlPanel;
